import { useContext } from 'react'

import { IMultiframeContextProps, MultiframeControlContext } from './Provider'

export const useMultiFrameControls = (): IMultiframeContextProps =>
  useContext(MultiframeControlContext)

export default useMultiFrameControls
